var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {DeleteBrandAsync as InvokeAsync , DeleteBrandSync as InvokeSync}

async function DeleteBrandAsync(LoginToken,BrandName)
{
    var DeleteBrandPromise = new Promise((resolve, reject) => {
        DeleteBrandSync(LoginToken,BrandName,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await DeleteBrandPromise;
}

function DeleteBrandSync(LoginToken,BrandName,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Admin/DeleteBrand',                
        data  : {
            AppID     :KEYS.AWS_APPID,
            BrandName :BrandName ,
            LoginToken:LoginToken,
            DeleteAll :'true'                  
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
